//======================
//       Sidebars
//======================
document.addEventListener('DOMContentLoaded', function() {
    let sidebars = document.querySelectorAll("*[class^=\"sidebar-\"]");

    sidebars.forEach((sidebar) => {
        let sidebarClasses = Array.from(sidebar.classList).filter(className => className.includes("sidebar-"));

        sidebarClasses.forEach((sidebarClass) => {
            let sidebarCheckbox = document.getElementById(sidebarClass + '-cb');
            let sidebarLabel = document.getElementById(sidebarClass + '-label');

            if (sidebarCheckbox != null) {
                // Hide sidebars if user clicks outside
                document.addEventListener("click", function(event) {
                    if (sidebarLabel.contains(event.target)) {
                        event.preventDefault();
                        sidebarCheckbox.checked = !sidebarCheckbox.checked;
                    } else if (sidebarCheckbox.checked && !sidebar.contains(event.target)) {
                        sidebarCheckbox.checked = false;
                    }
                });
            }
        });
    });
});